import { Colors } from "../constants/colors";

export const FONTS = {
  BOLD: "ey_interstate_bold",
  REGULAR: "ey_interstate",
  LIGHT: "ey_interstate_light",
};

export const FONT_FAMILIES = {
  BOLD: {
    fontFamily: FONTS.BOLD,
    fontWeight: 400,
  },
  REGULAR: {
    fontFamily: FONTS.REGULAR,
    fontWeight: 400,
  },
  LIGHT: {
    fontFamily: FONTS.LIGHT,
    fontWeight: 300,
  },
};

export const defaultFontSize = 14;

export const getEmFontSize = (size) => `${size}px`;

export const htmlStyles = {
  megaBannerTitle: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(30),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(42),
    letterSpacing: 0,
  },
  h1: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(18),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(24),
  },
  h2: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(18),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(24),
    letterSpacing: 0,
  },
  h3: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(16),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(24),
    letterSpacing: 0,
  },
  h4: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(22),
    letterSpacing: 0,
  },
  body1: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
  },
  body1bold: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(22),
    letterSpacing: 0,
  },
  body1Wide: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0.3,
  },
  body1boldWide: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(22),
    letterSpacing: 0.3,
  },
  body2: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(12),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(18),
    letterSpacing: 0,
  },
  body2bold: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(18),
    letterSpacing: 0,
  },
  body2Wide: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(12),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(18),
    letterSpacing: 0.3,
  },
  body2boldWide: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(18),
    letterSpacing: 0.3,
  },
  bold: {
    ...FONT_FAMILIES.BOLD,
  },
};

export const cardStyles = {
  cardTitle: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(18),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(24),
    letterSpacing: 1,
  },
  cardSectionHeading: {
    // Card & section heading
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(18),
    letterSpacing: 1.5,
    textTransform: "uppercase",
  },
  cardNumberText: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(14),
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  cardNumber: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(20),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(20),
    letterSpacing: 1.5,
  },
  cardNumberLarge: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(28),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(32),
    letterSpacing: 0,
  },
  rightColumnCard: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(15),
    letterSpacing: 0,
  },
};

export const miscStyles = {
  rightPanelLabel: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(13),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(16),
    letterSpacing: 1.5,
  },
  pageActionBar: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(18),
    letterSpacing: 0,
    fontWeight: 300,
  },
  accordionHeading: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
  },
  buttonDefault: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
    textTransform: "none",
  },
};

export const textStyles = {
  textLabel: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(10),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(16),
    letterSpacing: 0,
  },
  textValue: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(16),
    letterSpacing: 0.4,
  },
  textLink: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.BLUE400,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
  },
};

export const tableStyles = {
  tableHeader: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(11),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
    textTransform: "uppercase",
  },
  tableList: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
  },
  tableListSelected: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.GREY500,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
  },
  tableListDisabled: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY350,
    lineHeight: getEmFontSize(20),
    letterSpacing: 0,
  },
  tableListDescription: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(10),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(16),
    letterSpacing: 0,
  },
};

export const menuStyles = {
  leftNav: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(9),
    lineHeight: getEmFontSize(14),
    color: Colors.GREY450,
    letterSpacing: 0.5,
    textTransform: "uppercase",
  },
};

export const formStyles = {
  formElementLabel: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(12),
    color: Colors.GREY400,
    lineHeight: "auto",
    letterSpacing: 0,
  },
  formElementText: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(22),
    letterSpacing: 0.3,
  },
  formDropdownText: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(12),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(18),
    letterSpacing: 0.5,
  },
  formFieldHighlightText: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(12),
    color: Colors.GREY450,
    lineHeight: getEmFontSize(18),
    letterSpacing: 0.5,
  },
  tooltipText: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(10),
    color: Colors.GREY400,
    lineHeight: getEmFontSize(14),
    letterSpacing: 0,
  },
};

export default {
  ...htmlStyles,
  ...cardStyles,
  ...miscStyles,
  ...textStyles,
  ...tableStyles,
  ...menuStyles,
  ...formStyles,
};
